import React from 'react';
import { object, bool } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { Tooltip } from '@fiverr-private/fit';
import { isBuyerEligibleForMTPromotion } from '../../../../../utils/sellerLanguage';
import { inExperiment } from '../../../../../utils/experiments';
import { LIONS_CONTACT_SELLER_MT_PROMOTION } from '../../../../../utils/experiments/experimentsEnum';

const PromoteMTTooltip = ({ children }, { general, businessLayout, seller }) => {
    const { userId, abTests, locale, browserLanguage, countryCode, isMobile } = getContext();
    const { proficientLanguages } = seller;
    const showTooltip = isBuyerEligibleForMTPromotion({
        proficientLanguages,
        locale,
        browserLanguage,
        countryCode,
        userId,
        sellerId: general.sellerId,
        isStudio: general.isStudio,
        isBusiness: businessLayout
    }) &&
    inExperiment(LIONS_CONTACT_SELLER_MT_PROMOTION, abTests) &&
    !isMobile;

    if (!showTooltip) {
        return children;
    }

    return (
        <Tooltip className="co-white co-text-white"
            position={Tooltip.POSITIONS.BOTTOM}
            maxWidth={256}
            content={
                <div className="tbody-6">
                    <span className="text-semi-bold">
                        <I18n k="gig_page_perseus.seller_card.mt_promotion_title"/>
                    </span>
                    <span className="m-l-4">
                        <I18n k="gig_page_perseus.contact_seller_options.mt_promotion_body"/>
                    </span>
                </div>
            }>
            {children}
        </Tooltip>
    );
};

PromoteMTTooltip.contextTypes = {
    general: object,
    businessLayout: bool,
    seller: object
};

export default PromoteMTTooltip;
